import { render, staticRenderFns } from "./StartInfoSection.vue?vue&type=template&id=29ea8432&scoped=true&"
import script from "./StartInfoSection.vue?vue&type=script&lang=js&"
export * from "./StartInfoSection.vue?vue&type=script&lang=js&"
import style0 from "./StartInfoSection.vue?vue&type=style&index=0&id=29ea8432&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ea8432",
  null
  
)

export default component.exports